import React, { useEffect, useRef, useState } from 'react';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { getVisualizerBackgroundColorDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles'
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import styled from 'styled-components';
import { getZIndex } from '@process-advisor/process-miner/shared/theme';
import { Typography } from '@mui/material';
import { MinPercTasks } from '@process-advisor/process-miner/modals/minPercTasks'

const Diagram = styled.div<{ color: string }>`
    background-color: ${({ color }) => color};
    width: 600px;
    height: 60vh;
    border: hidden;
    canvas {
        outline: none;
    };
    z-index: ${getZIndex('diagram')};
`;

type Props = {
    data: {
        type: string,
        title: string,
        activity: string,
        occurrence: string,
        max_activity_tasks: string,
    },
}

export const ActivityStepAnalysisModal: React.FC = () => {
    const ref = useRef();
    const [data, setData] = React.useState<{ type: string, title: string, activity: string, occurrence: string, max_activity_tasks: string}>({ type: '', title: '', activity: '', occurrence: '', max_activity_tasks: ''});
    const [open, setOpen] = React.useState(false);
    const [showCloseIcon, setShowCloseIcon] = React.useState(true);
    
    const [showButtons, setShowButtons] = React.useState(true);
    const [VisualizerBackground, setVisualizerBackground] = React.useState<string>('');

    function onClose() {
        setOpen(false)
    }

    useApiListener(
        Event.openActivityStepAnalysisModal,
        ({ data }: Props) => {
            setOpen(true);
            setData(data);
            setVisualizerBackground(getVisualizerBackgroundColorDiagram());
            const timer = setTimeout(() => {
                apiProvider.rebuildASA()
            }, 100);
            return () => clearTimeout(timer);
        }
    );

    return (
        <StyledWrapper open={open} onClose={onClose}>
            <StyledModal >
                <StyledHeader>
                    <StyledTitle>{data.title}</StyledTitle>
                    {showCloseIcon ? <StyledIcon onClick={onClose} /> : <div />}
                </StyledHeader>
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ fontSize: '18px', fontWeight: '700', fontFamily: 'system-ui'
}}
                    component="div">
                    {data.activity}
                </Typography>                
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'system-ui'
}}
                    component="div">
                    {data.occurrence}
                </Typography>                
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'system-ui'
}}
                    component="div">
                    {data.max_activity_tasks}
                </Typography>                
                <StyledContent>
                    <Diagram ref={ref} id="gDiagramDivASA" color={VisualizerBackground} ></Diagram> 
                </StyledContent>
                {
                    showButtons && (
                        <StyledFooter>
                            <MinPercTasks/>
                            <Button label='Close' onClick={onClose} disabled={false} />
                        </StyledFooter>
                    )
                }
            </StyledModal>
        </StyledWrapper>
    );
};
